import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { memo, useContext, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { BRA_HELP_CENTER, BRA_SIZES, KIDS, KIDS_SIZES, MEN, MEN_SIZES_EXTENDED, SIZES_EXTENDED, SIZE_NAME_MAP, WOMEN, WOMEN_SIZES_EXTENDED, SIZES_KIDS } from '../../../config/constants-sizes';
import css from './SizingGeneral.module.scss';
import SegmentedControl from '../../../components/SegmentedControl';
import { OVContext } from '../../../utils/OVContext';
import { Select } from '@outdoor-voices/ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var womenSizes = [{
  category: 'Sizes',
  sizes: SIZES_EXTENDED,
  inches: false
}].concat(_toConsumableArray(WOMEN_SIZES_EXTENDED));
var menSizes = [{
  category: 'Sizes',
  sizes: SIZES_EXTENDED,
  inches: false
}].concat(_toConsumableArray(MEN_SIZES_EXTENDED));
var kidsSizes = [{
  category: 'Sizes',
  sizes: SIZES_KIDS,
  inches: false
}].concat(_toConsumableArray(KIDS_SIZES));
var braSizes = [{
  category: 'Sizes',
  sizes: BRA_HELP_CENTER,
  inches: false
}].concat(_toConsumableArray(BRA_SIZES));

var isCategory = function isCategory(category, isCat) {
  return category.toLowerCase().indexOf(isCat) > -1;
};

var MobileSizes = /*#__PURE__*/memo(function (_ref) {
  var sizes = _ref.sizes;

  var _useState = useState(sizes[0].sizes[0]),
      _useState2 = _slicedToArray(_useState, 2),
      currentSize = _useState2[0],
      setCurrentSize = _useState2[1];

  var sizeIndex = sizes[0].sizes.indexOf(currentSize);

  var onChange = function onChange(event) {
    setCurrentSize(event.target.value);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.mobile,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.mobileSelect,
      children: /*#__PURE__*/_jsx(Select, {
        id: "sizing-general",
        name: "sizing-general",
        label: "Select a size",
        onChange: onChange,
        options: sizes[0].sizes.map(function (size) {
          return {
            label: SIZE_NAME_MAP[size],
            value: size
          };
        }),
        value: currentSize
      })
    }), sizes.map(function (_ref2, index) {
      var category = _ref2.category,
          sizers = _ref2.sizes,
          inches = _ref2.inches;

      if (index === 0 || isCategory(category, 'shoes')) {
        return false;
      }

      return /*#__PURE__*/_jsxs("div", {
        className: css.mobileGroup,
        children: [/*#__PURE__*/_jsx("div", {
          children: category
        }), /*#__PURE__*/_jsxs("div", {
          className: css.mobileValue,
          children: [sizers[sizeIndex], inches ? '"' : '']
        })]
      }, category);
    })]
  });
});
MobileSizes.propTypes = {
  sizes: PropTypes.arrayOf(PropTypes.shape({
    sizes: PropTypes.arrayOf(PropTypes.string)
  }))
};

var SizingGeneral = function SizingGeneral(_ref3) {
  var type = _ref3.type;

  var _useContext = useContext(OVContext),
      tabletSmall = _useContext.tabletSmall;

  var _useState3 = useState(WOMEN),
      _useState4 = _slicedToArray(_useState3, 2),
      gender = _useState4[0],
      setGender = _useState4[1];

  var isApparel = type === 'Apparel';
  var className = cc([css.root, _defineProperty({}, css.mobileShow, true)]);
  var sizes = braSizes;

  if (isApparel) {
    sizes = gender === WOMEN ? womenSizes : gender === MEN ? menSizes : kidsSizes;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [isApparel && /*#__PURE__*/_jsx("div", {
      className: css.segmentedControl,
      children: /*#__PURE__*/_jsx(SegmentedControl, {
        segments: [{
          ariaLabel: 'Click to display the size guide for Women',
          label: WOMEN,
          onClick: function onClick() {
            return setGender(WOMEN);
          }
        }, {
          ariaLabel: 'Click to display the size guide for Men',
          label: MEN,
          onClick: function onClick() {
            return setGender(MEN);
          }
        }, {
          ariaLabel: 'Click to display the size guide for Kids',
          label: KIDS,
          onClick: function onClick() {
            return setGender(KIDS);
          }
        }],
        selectedIndex: gender === WOMEN ? 0 : gender === MEN ? 1 : 2
      })
    }), !tabletSmall && /*#__PURE__*/_jsx("div", {
      role: "table",
      children: /*#__PURE__*/_jsx("div", {
        role: "rowgroup",
        className: css.groupWrap,
        children: sizes.map(function (_ref5, groupIndex) {
          var sizes = _ref5.sizes,
              inches = _ref5.inches,
              category = _ref5.category;

          if (isCategory(category, 'shoes')) {
            return false;
          }

          var groupClass = cc([css.group, _defineProperty({}, css.first, groupIndex === 0), _defineProperty({}, css.last, groupIndex === sizes.length - 1)]);
          var isSize = isCategory(category, 'sizes');
          return /*#__PURE__*/_jsxs("div", {
            role: "row",
            className: groupClass,
            children: [/*#__PURE__*/_jsx("div", {
              className: cc([css.groupTitle, css.bold]),
              "aria-hidden": !isSize && category ? 'false' : 'true',
              children: !isSize && category
            }), sizes.map(function (size) {
              return /*#__PURE__*/_jsx("div", {
                className: css.groupCell,
                role: "cell",
                children: isSize ? /*#__PURE__*/_jsx("div", {
                  className: css.sizeHead,
                  children: size
                }) : size + (inches ? '"' : '')
              }, "cell-".concat(category, "-").concat(size, "-").concat(Math.random()));
            })]
          }, "group-".concat(category));
        })
      })
    }), tabletSmall && /*#__PURE__*/_jsx(MobileSizes, {
      sizes: sizes
    })]
  });
};

SizingGeneral.propTypes = {
  type: PropTypes.string
};
export default /*#__PURE__*/memo(SizingGeneral);